<template>
	<div class="date-picker-container">
		<div class="wrapper">
			<!-- 开始时间 -->
			<mobile-button class="date-box" color="#808080" @click="startClick">
				<span class="date-value">{{ startText }}</span>
				<van-icon class-prefix="mars-icon" name="date" />
			</mobile-button>
			<!-- 结束时间 -->
			<span class="separator">~</span>
			<mobile-button class="date-box" color="#808080" @click="endClick">
				<span class="date-value">{{ endText }}</span>
				<!-- <van-icon name="notes-o"/> -->
				<van-icon class-prefix="mars-icon" name="date" />
			</mobile-button>
		</div>

		<van-popup v-model="showPopup" position="bottom">
			<van-datetime-picker v-model="currentDate" type="date" @confirm="onConfirm" @cancel="onCancel" />
		</van-popup>
	</div>
</template>

<script>
import log from 'utils/log'
import moment from 'moment'
import MobileButton from 'components/mobile-button/index'
import utils from '@/utils/util'

export default {
	name: 'datePicker',
	components: { MobileButton },
	props: {
		value: {
			type: Array,
			required: true
		},
		start_placeholder: {
			type: String,
			default: '开始日期'
		},
		end_placeholder: {
			type: String,
			default: '结束日期'
		}
	},

	data() {
		return {
			currentDate: new Date(),
			showPopup: false,
			startDate: null,
			endDate: null,
			key: 'start'
		}
	},

	computed: {
		startText() {
			if (this.startDate) {
				return this.startDate
			} else {
				return this.start_placeholder
			}
		},

		endText() {
			console.log('endText', this.end_placeholder)
			if (this.endDate) {
				return this.endDate
			} else {
				return this.end_placeholder
			}
		}
	},

	watch: {
		value: {
			immediate: true,
			handler(newVal) {
				console.log('watch---value', newVal)
				if (utils.isNotEmpty(newVal)) {
					this.startDate = newVal[0]
					this.endDate = newVal[1]
				} else {
					this.startDate = null
					this.endDate = null
				}
			}
		}
	},

	methods: {
		onConfirm(value) {
			log('64 value', value)
			this.showPopup = false
			let m = moment(value)
			let fmt = 'YYYY-MM-DD'
			let t = m.format(fmt)
			this.setProps(t)
			// log('70 t is', t)
		},

		onCancel() {
			this.showPopup = false
		},

		startClick() {
			this.key = 'start'
			this.showPopup = true
			if (utils.isNotEmpty(this.value[0])) {
				this.currentDate = new Date(this.value[0])
			} else {
				this.currentDate = new Date()
			}
		},

		endClick() {
			this.key = 'end'
			this.showPopup = true
			if (utils.isNotEmpty(this.value[1])) {
				this.currentDate = new Date(this.value[1])
			} else {
				this.currentDate = new Date()
			}
		},

		setProps(date) {
			if (this.key === 'start') {
				this.startDate = date
				this.value[0] = date
			} else if (this.key === 'end') {
				this.endDate = date
				this.value[1] = date
			}
			log('93 date time', this.value)
			this.$emit('input', this.value)
		}
	}
}
</script>

<style lang="scss" scoped></style>
